import { send } from 'server';

import { TGetTermsAndConditionsHistory } from '../../types';

export const getTermsAndConditionsHistory: TGetTermsAndConditionsHistory = () => send({
    ID: 35790,
    responses: [35791, 35792],
    description: 'Get player Terms and Conditions history'
});
